export default __webpack_public_path__ + "static/vehicle_warranty_3-b5772c378a2d78e43e93edacfa1a937c.webp";